import { JSX } from 'preact'
import { CSSRule } from '@gsc/types'
import { useStyleRegistryState } from './StyleRegistryProvider'
import { SerializedStyle } from './SerializedStyle'

interface Props {
  initial?: CSSRule[]
}

export function RegisteredStyles({ initial = [] }: Props): JSX.Element {
  const styles = useStyleRegistryState() ?? []
  return (
    <>
      {[...initial, ...styles].map(s => (
        <SerializedStyle style={s} key={s.id} />
      ))}
    </>
  )
}
